export const selectStudyPlan = state => state.studyPlan;
